"use client";

import React, { useEffect, useState } from 'react';
import { useTheme } from '@/context/ThemeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import styles from '@/styles/ThemeToggle.module.css';

interface ThemeToggleProps {
  onThemeChange?: () => void;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ onThemeChange }) => {
  const [mounted, setMounted] = useState(false);
  const { theme, toggleTheme } = useTheme();

  const handleToggle = () => {
    toggleTheme();
    if (onThemeChange) onThemeChange();
  };

  // After mounting, we have access to the theme
  useEffect(() => {
    setMounted(true);
  }, []);

  // Prevent rendering on the server
  if (!mounted) {
    // Return a placeholder with the same dimensions to prevent layout shift
    return (
      <button 
        className={styles.themeToggle}
        aria-hidden="true"
        style={{ visibility: 'hidden' }}
      />
    );
  }

  return (
    <button
      className={styles.themeToggle}
      onClick={handleToggle}
      aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme mode`}
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
      aria-pressed={theme === 'dark'}
    >
      <FontAwesomeIcon icon={theme === 'light' ? faMoon : faSun} />
    </button>
  );
};

export default ThemeToggle;